<template>
    <div class="no-hero g-px g-mb">
        <div class="row-c-nm event-form">
            <h2>{{heading}}</h2>
            <form class="form form--error-handling" enctype="multipart/form-data" @submit.prevent="submit">
                <!-- Slider main container -->
                <div class="swiper-container">
                    <!-- Additional required wrapper -->
                    <div class="swiper-wrapper">

                        <!-- Slide 1: INTRO -->
                        <div class="swiper-slide" v-if="newEntry">
                            <h3>
                                <slot name="step1-title">Intentieverklaring</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step1-text">Reveil in jouw gemeente</slot>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <button type="button" @click="nextSlide" class="btn btn--green">Volgende</button>
                            </div>
                        </div>

                        <!-- Slide 2: CONTACT -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step2-title">Gegevens centrale contactpersoon</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step2-text">Voor Reveil is het handig om de coördinaten te ontvangen van de spilfiguur/centrale contactpersoon van het  Reveilmoment. Als jij dat bent, mag je gewoon jouw gegevens noteren.</slot>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.firstNameContact.error }" class="form-group">
                                    <label for="input-first-name-contact">Voornaam <span>*</span></label>
                                    <input id="input-first-name-contact"
                                           name="firstNameContact"
                                           type="text"
                                           v-model="fields.firstNameContact.val"
                                           @keyup="checkErrorReq(fields.firstNameContact)"
                                    >
                                    <span v-if="fields.firstNameContact.error">Gelieve een voornaam in te geven.</span>
                                </div>
                                <div :class="{'error': fields.lastNameContact.error }" class="form-group">
                                    <label for="input-last-name-contact">Familienaam <span>*</span></label>
                                    <input id="input-last-name-contact"
                                           name="lastNameContact"
                                           type="text"
                                           v-model="fields.lastNameContact.val"
                                           @keyup="checkErrorReq(fields.lastNameContact)"
                                    >
                                    <span v-if="fields.lastNameContact.error">Gelieve een familienaam in te geven.</span>
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.jobTitleContact.error }" class="form-group">
                                    <label for="input-job-title-contact">Functie <span>*</span></label>
                                    <v-select label="label" :clearable="false" :value="fields.jobTitleContact.val" :options="jobTitleOptions" id="input-job-title-contact" @input="setJobTitleContact">
                                    </v-select>
                                    <span v-if="fields.jobTitleContact.error">Gelieve een functie te selecteren.</span>
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.emailContact.error }" class="form-group">
                                    <label for="input-email-contact">E-mailadres <span>*</span></label>
                                    <input id="input-email-contact"
                                           name="emailContact"
                                           type="text"
                                           v-model="fields.emailContact.val"
                                           @keyup="checkErrorMail(fields.emailContact)"
                                    >
                                    <span v-if="fields.emailContact.error">Gelieve een correct e-mailadres in te geven.</span>
                                </div>
                                <div class="form-group">
                                    <label for="input-phone-contact">Telefoonnummer</label>
                                    <input id="input-phone-contact"
                                           name="phoneContact"
                                           type="text"
                                           v-model="fields.phoneContact.val">
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.city.error }" class="form-group">
                                    <label for="input-city">Gemeente of stad waar je Reveil wil brengen <span>*</span></label>
                                    <input id="input-city"
                                           name="city"
                                           type="text"
                                           v-model="fields.city.val"
                                           @keyup="checkErrorReq(fields.city)"
                                    >
                                    <span v-if="fields.city.error">Gelieve een gemeente of stad in te geven.</span>
                                </div>
                                <div :class="{'error': fields.zipcode.error }" class="form-group">
                                    <label for="input-zipcode">Postcode <span>*</span></label>
                                    <input id="input-zipcode"
                                           name="zipcode"
                                           type="text"
                                           v-model="fields.zipcode.val"
                                           @keyup="checkErrorReq(fields.zipcode)"
                                    >
                                    <span v-if="fields.zipcode.error">Gelieve een postcode in te geven.</span>
                                </div>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose" v-if="newEntry">Terug</button>
                                    <button type="button" @click="nextSlide" class="btn btn--green">Volgende</button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 3: 1 NOVEMBER -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step3-title">1 November</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step3-text"></slot>
                            </div>
                            <div class="form-field-wrapper form-field-wrapper--thirds">
                                <div :class="{'error': fields.dateStart.error }" class="form-group">
                                    <label for="input-date-start">Datum <span>*</span></label>
                                    <input id="input-date-start"
                                           name="dateStart"
                                           type="date"
                                           v-model="fields.dateStart.val"
                                           @change="checkErrorReq(fields.dateStart)"
                                    >
                                    <span v-if="fields.dateStart.error">Gelieve een datum in te geven.</span>
                                </div>
                                <div class="form-group">
                                    <label for="input-startuur">Startuur</label>
                                    <input id="input-startuur"
                                           name="startuur"
                                           type="time"
                                           v-model="fields.startuur.val"
                                    >
                                </div>
                                <div class="form-group">
                                    <label for="input-einduur">Einduur</label>
                                    <input id="input-einduur"
                                           name="einduur"
                                           type="time"
                                           v-model="fields.einduur.val"
                                    >
                                </div>
                            </div>
                            <div :class="{'error': fields.locationName.error }" class="form-group">
                                <label for="input-location-name">Naam van de locatie van je troostinitiatief (bv. café Den Dreupel, begraafplaats Deerlijk, troostplek Dilbeek…) <span>*</span></label>
                                <input id="input-location-name"
                                       name="locationName"
                                       type="text"
                                       v-model="fields.locationName.val"
                                       @keyup="checkErrorReq(fields.locationName)"
                                >
                                <span v-if="fields.locationName.error">Gelieve een naam in te geven.</span>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.locationStreet.error }" class="form-group">
                                    <label for="input-location-street">Straat <span>*</span></label>
                                    <input id="input-location-street"
                                            name="locationStreet"
                                            type="text"
                                            v-model="fields.locationStreet.val"
                                            @keyup="checkErrorReq(fields.locationStreet)"
                                    >
                                    <span v-if="fields.locationStreet.error">Gelieve een straat in te geven.</span>
                                </div>
                                <div class="form-group">
                                    <div class="w-1/5">
                                        <label for="input-location-nr">Nr</label>
                                        <input id="input-location-nr"
                                                name="locationNr"
                                                type="text"
                                                v-model="fields.locationNr.val"
                                                style="border-color:#52746A"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="form-field-wrapper">
                                <div :class="{'error': fields.locationZipcode.error }" class="form-group">
                                    <label for="input-location-zipcode">Postcode <span>*</span></label>
                                    <input id="input-location-zipcode"
                                        name="zipcode"
                                        type="text"
                                        v-model="fields.locationZipcode.val"
                                        @keyup="checkErrorReq(fields.locationZipcode)"
                                    >
                                    <span v-if="fields.locationZipcode.error">Gelieve een postcode in te geven.</span>
                                </div>
                                <div :class="{'error': fields.locationCity.error }" class="form-group">
                                    <label for="input-location-city">Gemeente of stad <span>*</span></label>
                                    <input id="input-location-city"
                                        name="locationCity"
                                        type="text"
                                        v-model="fields.locationCity.val"
                                        @keyup="checkErrorReq(fields.locationCity)"
                                    >
                                    <span v-if="fields.locationCity.error">Gelieve een gemeente of stad in te geven.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Omschrijf jouw evenement</label>
                                <p class="mb-0">
                                    Hoe ziet de programmatie er uit? Welke artiesten / dichters / vertellers komen een eerbetoon brengen op de begraafplaats?<br>
                                    Pas op: jouw info verschijnt onbewerkt op de website.
                                </p>
                                <small>ENTER = nieuwe paragraaf, SHIFT+ENTER = nieuwe regel</small>
                                <ckeditor :editor="editor" v-model="fields.contentBlock.val" :config="editorConfig"></ckeditor>
                            </div>
                            <div class="form-field-wrapper">
                                <div class="form-group">
                                    <label>Foto</label>
                                    <file-upload :folder-id="asset.folderId" :field-id="asset.fieldId" :element-id="asset.elementId" :original-name="asset.originalName" :url="asset.url" @uploadComplete="onUploadComplete"></file-upload>
                                </div>
                                <div class="form-group">
                                    <label>Links</label>
                                    <p class="mb-0">Links naar jouw website of Facebook-event, ...</p>
                                    <small>Vergeet <em>http://</em> niet!</small>
                                    <table class="w-full">
                                        <tbody>
                                        <tr v-for="(row, index) in fields.externalLinks.val" :key="index">
                                            <td>
                                                <input type="text" v-model="row.link" placeholder="http://">
                                            </td>
                                            <td class="text-right w-10">
                                                <button v-if="index>0" class="btn btn--rose" type="button" @click="deleteRow(fields.externalLinks.val, row)">Wis</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <button type="button" class="btn btn--rose mt-1" @click="addRow(fields.externalLinks.val, {link: ''})">+ Voeg een link toe</button>
                                </div>
                            </div>
                            <div :class="{'error': fields.eventType.error }" class="form-group">
                                <label>Registreer je een troostconcert of een Radio Reveil Café? <span>*</span></label>
                                <div class="checkbox">
                                    <input hidden
                                           id="input-event-type-event"
                                           name="eventType"
                                           type="radio"
                                           v-model="fields.eventType.val"
                                           value="event"
                                           :disabled="!newEntry"
                                           @change="checkErrorChk(fields.eventType)"
                                    >
                                    <label for="input-event-type-event">Troostconcert</label>
                                </div>
                                <div class="checkbox">
                                    <input hidden
                                           id="input-event-type-cafe"
                                           name="eventType"
                                           type="radio"
                                           v-model="fields.eventType.val"
                                           value="radioReveilCafe"
                                           :disabled="!newEntry"
                                           @change="checkErrorChk(fields.eventType)"
                                    >
                                    <label for="input-event-type-cafe">Radio Reveil Café</label>
                                </div>
                                <span v-if="fields.eventType.error">Gelieve een keuze aan te duiden.</span>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose">Terug</button>
                                    <button type="button" @click="nextSlide" class="btn btn--green" v-if="newEntry || !isCafe">Volgende</button>
                                    <button type="button" @click="submitCafeEdit" class="btn btn--green" :disabled="disableSubmit" v-if="!newEntry && isCafe">
                                        <span v-show="!disableSubmit">Verzenden</span>
                                        <span v-show="disableSubmit">Even geduld</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 4: BESTELLEN -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step4-title">Bestellen</slot>
                            </h3>
                            <div class="rte mb-16">
                                <slot name="step4-text"></slot>
                            </div>
                            <div v-if="fields.orderHistory.val">
                                <h3>Reeds besteld</h3>
                                <div class="rte mb-16">
                                    <p>Je kan eventueel nog extra items bijbestellen.</p>
                                    <p v-html="fields.orderHistory.val"></p>
                                </div>
                            </div>
                            <div v-for="group in articles" class="mb-16">
                                <h3>{{group.title}}</h3>
                                <img v-if="group.image" :src="group.image" alt="" class="w-full mb-6">
                                <div class="rte mb-6" v-html="group.text"></div>
                                <!-- Radiobuttons -->
                                <div class="form-group" v-if="group.type=='radiobuttons'">
                                    <div class="checkbox" v-for="item in group.items">
                                        <input hidden
                                               type="radio"
                                               :ref="group.groupSlug + `-` + item.itemSlug"
                                               :id="group.groupSlug + `-` + item.itemSlug"
                                               :name="group.groupSlug"
                                               :value="item.item"
                                               @change="setLineItem(group.type, group.groupSlug, item.itemSlug, group.title, item.item)"
                                        >
                                        <label :for="group.groupSlug + `-` + item.itemSlug">{{item.item}}</label>
                                    </div>
                                    <div class="checkbox">
                                        <input hidden
                                               type="radio"
                                               :ref="group.groupSlug + `-nee-bedankt`"
                                               :id="group.groupSlug"
                                               :name="group.groupSlug"
                                               value="Nee bedankt"
                                               @change="setLineItem(group.type, group.groupSlug, 'nee-bedankt', group.title, 'Nee bedankt')"
                                        >
                                        <label :for="group.groupSlug">Nee bedankt, niet nodig voor mijn gemeente</label>
                                    </div>
                                </div>
                                <!-- Checkboxes -->
                                <div class="form-group" v-if="group.type=='checkboxes'">
                                    <div class="checkbox checkbox--square" v-for="item in group.items">
                                        <input hidden
                                               type="checkbox"
                                               :ref="group.groupSlug + `-` + item.itemSlug"
                                               :id="group.groupSlug + `-` + item.itemSlug"
                                               :value="item.item"
                                               @change="setLineItem(group.type, group.groupSlug, item.itemSlug, group.title, item.item)"
                                        >
                                        <label :for="group.groupSlug + `-` + item.itemSlug">{{item.item}}</label>
                                    </div>
                                </div>
                                <!-- Inputs -->
                                <div class="form-group" v-if="group.type=='aantallen'">
                                    <div class="input input--number" v-for="item in group.items">
                                        <input type="number"
                                               :ref="group.groupSlug + `-` + item.itemSlug"
                                               :id="group.groupSlug + `-` + item.itemSlug"
                                               :name="group.groupSlug"
                                               value=""
                                               placeholder="0"
                                               min="0"
                                               @change="setLineItem(group.type, group.groupSlug, item.itemSlug, group.title, item.item)"
                                        >
                                        <label :for="group.groupSlug + `-` + item.itemSlug">{{item.item}}</label>
                                    </div>
                                </div>
                            </div>

                            <div v-show="orderActive">
                                <div :class="{'error': fields.shippingAddress.error }" class="form-group">
                                    <label for="input-shipping-address">Naar welk adres mogen we jouw bestelling verzenden? <span>*</span></label>
                                    <textarea id="input-shipping-address"
                                              name="shippingAddress"
                                              rows="3"
                                              v-model="fields.shippingAddress.val"
                                              @keyup="checkErrorReq(fields.shippingAddress)"
                                    ></textarea>
                                    <span v-if="fields.shippingAddress.error">Gelieve een adres in te geven.</span>
                                </div>
                                <div :class="{'error': fields.invoice.error }" class="form-group">
                                    <label>Wens je een factuur? <span>*</span></label>
                                    <div class="checkbox">
                                        <input hidden
                                               id="input-invoice-true"
                                               name="invoice"
                                               type="radio"
                                               value="yes"
                                               v-model="fields.invoice.val"
                                               @change="checkErrorChk(fields.invoice)"
                                        >
                                        <label for="input-invoice-true">Ja</label>
                                    </div>
                                    <div class="checkbox">
                                        <input hidden
                                               id="input-invoice-false"
                                               name="invoice"
                                               type="radio"
                                               value="no"
                                               v-model="fields.invoice.val"
                                               @change="checkErrorChk(fields.invoice)"
                                        >
                                        <label for="input-invoice-false">Nee</label>
                                    </div>
                                    <span v-if="fields.invoice.error">Gelieve een antwoord aan te duiden.</span>
                                </div>
                                <div :class="{'error': fields.invoicingAddress.error }" class="form-group" v-show="fields.invoice.val == 'yes'">
                                    <label for="input-invoicing-address">Op welk adres mag de factuur staan? (factuur wordt via pdf bezorgd via mail) <span>*</span></label>
                                    <textarea id="input-invoicing-address"
                                              name="invoicingAddress"
                                              rows="3"
                                              v-model="fields.invoicingAddress.val"
                                              @keyup="checkErrorReq(fields.invoicingAddress)"
                                    ></textarea>
                                    <span v-if="fields.invoicingAddress.error">Gelieve een adres in te geven.</span>
                                </div>
                                <div class="form-group" v-show="fields.invoice.val == 'yes'">
                                    <label for="input-invoicing-data">Welke extra gegevens moeten er nog op de factuur komen? vb. bestelbonnummer.</label>
                                    <textarea id="input-invoicing-data"
                                              name="extraDataInvoice"
                                              rows="3"
                                              v-model="fields.extraDataInvoice.val"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose">Terug</button>
                                    <button type="button" @click="nextSlide" class="btn btn--green" v-if="newEntry">Volgende</button>
                                    <button type="submit" class="btn btn--green" v-if="!newEntry">Verzenden</button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 5: VRAGEN -->
                        <div class="swiper-slide" v-if="newEntry">
                            <h3>
                                <slot name="step5-title">Nog vragen of onduidelijkheden?</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step5-text">
                                    <p>Aarzel niet om <a href="/contact">ons te contacteren</a> of hieronder jouw specifieke vraag neer te schrijven.<br>We kijken alvast heel erg uit naar jullie aanpak.</p>
                                </slot>
                            </div>
                            <div class="form-group">
                                <label for="input-remarks">Jouw vragen of opmerkingen</label>
                                <textarea id="input-remarks" name="remarks" rows="8" v-model="fields.remarks.val"></textarea>
                            </div>
                            <div class="swiper-slider__btn-row">
                                <span>Stap {{slide}}/{{totalSlides}}</span>
                                <div>
                                    <button type="button" @click="prevSlide" class="btn btn--rose">Terug</button>
                                    <button type="submit" class="btn btn--green" :disabled="this.disableSubmit">
                                        <span v-show="!this.disableSubmit">Verzenden</span>
                                        <span v-show="this.disableSubmit">Even geduld</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Slide 6: SENT -->
                        <div class="swiper-slide">
                            <h3>
                                <slot name="step6-title">Evenement geregistreerd</slot>
                            </h3>
                            <div class="rte mb-6">
                                <slot name="step6-text">
                                    <p>Bedankt!</p>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import vSelect from 'vue-select'
import CKEditor from '@ckeditor/ckeditor5-vue'
import CKEditorStyle from '@ckeditor/ckeditor5-build-classic'
import FileUpload from './components/FileUpload.vue'
import VueSmoothScroll from 'vue2-smooth-scroll'
import debounce from 'debounce'

window.axios = axios

export default {
    props: {
        entryId: Number,
        user: Object,
        articles: Array
    },
    components: {
        ckeditor: CKEditor.component,
        vSelect,
        FileUpload,
        VueSmoothScroll
    },
    data() {
        return {
            editor: CKEditorStyle,
            editorConfig: {
                toolbar: ['bold','italic','|','numberedlist','bulletedlist','|','link','|','undo','redo']
            },
            slide: 1,
            totalSlides: 5,
            disableSubmit: false,
            heading: 'Registreer je troostinitiatief',
            jobTitleOptions: [
                {
                    value: 'stadsdienst',
                    label: 'Stadsdienst'
                },
                {
                    value: 'schepen',
                    label: 'Schepen'
                },
                {
                    value: 'burgemeester',
                    label: 'Burgemeester'
                },
                {
                    value: 'onafhankelijkeOrganisator',
                    label: 'Onafhankelijke organisator'
                },
                {
                    value: 'fermMedewerker',
                    label: 'Ferm-medewerker'
                },
                {
                    value: 'andere',
                    label: 'Andere'
                }
            ],
            newEntry: true,
            asset: {
                folderId: 10, // evenementen
                fieldId: 107, // field Image
                elementId: null,
                originalName: null,
                url: null
            },
            fields: {
                orderHistory: {
                    val: false,
                    error: false
                },
                entryId: {
                    val: false,
                    error: false
                },
                title: {
                    val: '',
                    error: false
                },
                eventType: {
                    val: null,
                    error: false
                },
                dateStart: {
                    val: '',
                    error: false
                },
                startuur: {
                    val: '',
                    error: false
                },
                einduur: {
                    val: '',
                    error: false
                },
                firstNameContact: {
                    val: '',
                    error: false
                },
                lastNameContact: {
                    val: '',
                    error: false
                },
                jobTitleContact: {
                    val: '',
                    error: false
                },
                emailContact: {
                    val: '',
                    error: false
                },
                phoneContact: {
                    val: '',
                    error: false
                },
                zipcode: {
                    val: '',
                    error: false
                },
                city: {
                    val: '',
                    error: false
                },
                locationName: {
                    val: '',
                    error: false
                },
                locationStreet: {
                    val: '',
                    error: false
                },
                locationNr: {
                    val: '',
                    error: false
                },
                locationZipcode: {
                    val: '',
                    error: false
                },
                locationCity: {
                    val: '',
                    error: false
                },
                contentBlock: {
                    val: '',
                    error: false
                },
                image: {
                    val: '',
                    error: false
                },
                externalLinks: {
                    val: [{
                        link: ''
                    }],
                    error: false
                },
                lineItems: {
                    val: [],
                    error: false
                },
                shippingAddress: {
                    val: '',
                    error: false
                },
                invoicingAddress: {
                    val: '',
                    error: false
                },
                extraDataInvoice: {
                    val: '',
                    error: false
                },
                invoice: {
                    val: null,
                    error: false
                },
                remarks: {
                    val: '',
                    error: false
                }
            }
        }
    },
    computed: {
        orderActive: function() {
            return this.fields.lineItems.val.length > 0;
        },
        isCafe: function() {
            return this.fields.eventType.val === 'radioReveilCafe';
        }
    },
    methods: {
        validateSlide3() {
            const locationZipcode = !this.checkRequired(this.fields.locationZipcode);
            const locationCity = !this.checkRequired(this.fields.locationCity);
            const locationName = !this.checkRequired(this.fields.locationName);
            const locationStreet = !this.checkRequired(this.fields.locationStreet);
            const dateStart = !this.checkRequired(this.fields.dateStart);
            const eventType = !this.checkCheckboxes(this.fields.eventType);

            return locationZipcode && locationCity && locationName && locationStreet && dateStart && eventType;
        },
        submitCafeEdit() {
            this.setLocalStorage()
            if (this.validateSlide3()) {
                this.submit()
            }
        },
        nextSlide() {
            this.setLocalStorage()
            switch (this.slide) {
                case 2:
                    const firstNameContact = !this.checkRequired(this.fields.firstNameContact);
                    const lastNameContact = !this.checkRequired(this.fields.lastNameContact);
                    const jobTitleContact = !this.checkRequired(this.fields.jobTitleContact);
                    const emailContact = !this.checkEmail(this.fields.emailContact);
                    const city = !this.checkRequired(this.fields.city);
                    const zipcode = !this.checkRequired(this.fields.zipcode);

                    if (firstNameContact && lastNameContact && jobTitleContact && emailContact && city && zipcode) {
                        this.slide += 1;
                        this.swiper.slideNext();
                    }
                    break;

                case 3:
                    if (this.validateSlide3()) {
                        if (this.isCafe) {
                            this.slide = 5;
                            this.swiper.slideTo(4);
                        } else {
                            this.slide += 1;
                            this.swiper.slideNext();
                        }
                    }
                    break;

                case 4:
                    const invoice = this.orderActive ? !this.checkCheckboxes(this.fields.invoice) : true ;
                    const shippingAddress = this.orderActive ? !this.checkRequired(this.fields.shippingAddress) : true ;
                    const invoicingAddress = this.fields.invoice.val == 'yes' ? !this.checkRequired(this.fields.invoicingAddress) : true ;

                    if (invoice && shippingAddress && invoicingAddress) {
                        this.slide += 1;
                        this.swiper.slideNext();
                    }
                    break;

                default:
                    this.slide += 1;
                    this.swiper.slideNext();
            }

            this.$smoothScroll({
                scrollTo: document.getElementById("app"),
                updateHistory: false
            })
        },
        prevSlide() {
            this.setLocalStorage()
            if (this.slide === 5 && this.isCafe) {
                this.slide = 3;
                this.swiper.slideTo(2);
            } else {
                this.slide -= 1
                this.swiper.slidePrev()
            }
            this.$smoothScroll({
                scrollTo: document.getElementById("app"),
                updateHistory: false
            })
        },
        setLocalStorage() {
            localStorage.setItem('fieldsEvent', JSON.stringify(this.fields));
        },
        getLocalStorage() {
            if(localStorage.getItem('fieldsEvent') !== null) {
                var fields = JSON.parse(localStorage.getItem('fieldsEvent'));
                Object.entries(fields).forEach(([key, value]) => {
                    this.fields[key] = value;
                });
            }
        },
        checkRequired(field) {
            const bool = field.val === ''
            field.error = bool
            return bool
        },
        checkEmail(field) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const bool = re.test(String(field.val).toLowerCase())
            field.error = !bool
            return !bool
        },
        checkCheckboxes(field) {
            const bool = field.val === null
            field.error = bool
            return bool
        },
        checkErrorReq(field) {
            if (field.val !== '') field.error = false
        },
        checkErrorMail(field) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const bool = re.test(String(field.val).toLowerCase())
            if (bool) field.error = false
        },
        checkErrorChk(field) {
            const bool = field.val !== null
            if (bool) field.error = false
        },
        setJobTitleContact(val) {
            this.fields.jobTitleContact.val = val.value
            // validation
            const bool = val !== null
            if (bool) this.fields.jobTitleContact.error = false
        },
        addRow(rows, row) {
            rows.push(row)
        },
        deleteRow(rows, row) {
            var i = rows.indexOf(row)
            if (i > -1) {
                rows.splice(i, 1)
            }
        },
        onUploadComplete(args) {
            this.fields.image.val = args.assetId
        },
        getEntry(entryId) {
            window.axios.get('/api/events/'+entryId+'.json')
                .then(response => {
                    if(response.data) {

                        console.debug(response.data)

                        this.fields.orderHistory.val = response.data.orderHistory
                        console.debug(this.fields.orderHistory, response.data.orderHistory)
                        this.fields.entryId.val = response.data.entryId
                        this.fields.title.val = response.data.title
                        this.fields.eventType.val = response.data.type
                        this.fields.dateStart.val = response.data.dateStart
                        this.fields.startuur.val = response.data.startuur
                        this.fields.einduur.val = response.data.einduur
                        this.fields.firstNameContact.val = response.data.firstNameContact
                        this.fields.lastNameContact.val = response.data.lastNameContact
                        this.fields.jobTitleContact.val = response.data.jobTitleContact
                        this.fields.emailContact.val = response.data.emailContact
                        this.fields.phoneContact.val = response.data.phoneContact
                        this.fields.city.val = response.data.city
                        this.fields.zipcode.val = response.data.zipcode
                        this.fields.locationName.val = response.data.locationName
                        this.fields.locationStreet.val = response.data.locationStreet
                        this.fields.locationNr.val = response.data.locationNr
                        this.fields.locationCity.val = response.data.locationCity
                        this.fields.locationZipcode.val = response.data.locationZipcode
                        this.fields.contentBlock.val = response.data.contentBlock
                        if(response.data.image !== null) {
                            this.fields.image.val = response.data.image.assetId
                            this.asset.originalName = response.data.image.filename
                            this.asset.url = response.data.image.url
                        }
                        if(response.data.externalLinks !== null) {
                            this.fields.externalLinks.val = response.data.externalLinks
                        }
                        this.fields.remarks.val = response.data.remarks
                        this.fields.invoice.val = response.data.invoice
                        this.fields.shippingAddress.val = response.data.shippingAddress
                        this.fields.invoicingAddress.val = response.data.invoicingAddress
                        this.fields.extraDataInvoice.val = response.data.extraDataInvoice
                        this.assets.elementId = response.data.entryId
                    }
                })
                .catch(error => console.log(error))
        },
        setLineItem(type, groupSlug, itemSlug, group, item) {
            var ref = groupSlug + `-` + itemSlug;
            switch (type) {
                case 'radiobuttons':
                    this.fields.lineItems.val.forEach(item => {
                        if(item.group == groupSlug) {
                            item.qty = 0;
                        }
                    });
                    this.fields.lineItems.val.push({
                        'groupSlug': groupSlug,
                        'itemSlug': itemSlug,
                        'group': group,
                        'item': item,
                        'qty': 1
                    });
                    break;
                case 'checkboxes':
                    this.fields.lineItems.val.forEach(item => {
                        if(item.group == groupSlug && item.item == itemSlug) {
                            item.qty = 0;
                        }
                    });
                    this.fields.lineItems.val.push({
                        'groupSlug': groupSlug,
                        'itemSlug': itemSlug,
                        'group': group,
                        'item': item,
                        'qty': this.$refs[ref][0].checked ? 1 : 0
                    });
                    break;
                case 'aantallen':
                    this.fields.lineItems.val.forEach(item => {
                        if(item.group == groupSlug && item.item == itemSlug) {
                            item.qty = 0;
                        }
                    });
                    this.fields.lineItems.val.push({
                        'groupSlug': groupSlug,
                        'itemSlug': itemSlug,
                        'group': group,
                        'item': item,
                        'qty': this.$refs[ref][0].value
                    });
                    break;
                default:
                    console.error('article group not supported: ' + groupSlug);
            }

            this.fields.lineItems.val = this.fields.lineItems.val.filter(function(item) {
                return item.qty > 0;
            });
        },
        submit () {

            this.disableSubmit = true

            var action = '/actions/reveil-module/events/save-entry'
            var csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
            var formData = new FormData()

            formData.set('CRAFT_CSRF_TOKEN', csrfToken)
            formData.set('entryId', this.fields.entryId.val)
            formData.set('entryType', this.fields.eventType.val)
            formData.set('dateStart', this.fields.dateStart.val)
            formData.set('startuur', this.fields.startuur.val)
            formData.set('einduur', this.fields.einduur.val)
            formData.set('firstNameContact', this.fields.firstNameContact.val)
            formData.set('lastNameContact', this.fields.lastNameContact.val)
            formData.set('jobTitleContact', this.fields.jobTitleContact.val)
            formData.set('emailContact', this.fields.emailContact.val)
            formData.set('phoneContact', this.fields.phoneContact.val)
            formData.set('city', this.fields.city.val)
            formData.set('zipcode', this.fields.zipcode.val)
            formData.set('locationName', this.fields.locationName.val)
            formData.set('locationStreet', this.fields.locationStreet.val)
            formData.set('locationNr', this.fields.locationNr.val)
            formData.set('locationCity', this.fields.locationCity.val)
            formData.set('locationZipcode', this.fields.locationZipcode.val)
            formData.set('contentBlock', this.fields.contentBlock.val)
            formData.set('image', this.fields.image.val)
            formData.set('externalLinks', JSON.stringify(this.fields.externalLinks.val))
            formData.set('lineItems', JSON.stringify(this.fields.lineItems.val))
            formData.set('remarks', this.fields.remarks.val)

            if(this.orderActive) {
                formData.set('shippingAddress', this.fields.shippingAddress.val)
                formData.set('invoice', this.fields.invoice.val)
                if(this.fields.invoice.val == 'yes') {
                    formData.set('invoicingAddress', this.fields.invoicingAddress.val)
                    formData.set('extraDataInvoice', this.fields.extraDataInvoice.val)
                }
            }

            window.axios({
                method: 'post',
                headers: {
                    "Content-Type": 'application/x-www-form-urlencoded',
                },
                data: formData,
                url: action
            }).then((response) => {
                console.log(response)
                if(response.data.success == true) {
                    this.fields.entryId = response.data.entryId
                    if(this.newEntry) {
                        this.nextSlide()
                        localStorage.removeItem('fieldsEvent')
                    }else{
                        localStorage.removeItem('fieldsEvent')
                        window.location.href = "/account"
                    }
                }else{
                    this.disableSubmit = false
                    alert(response.data.message || 'Verzenden mislukt. Gelieve het formulier na te zien.')
                }
            }).catch((error) => {
                this.disableSubmit = false
                const message = error.response && error.response.data && error.response.data.message
                alert(message || 'Verzenden mislukt. Gelieve opnieuw te proberen.')
                console.log(error)
            })
        }
    },
    mounted() {
        this.swiper = new Swiper('.swiper-container', {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 60,
            simulateTouch: false,
            autoHeight: false,
        })
    },
    created() {
        if(this.entryId !== undefined) {
            this.heading = 'Evenement aanpassen'
            this.newEntry = false
            this.totalSlides = 4
            this.slide = 2
            this.getEntry(this.entryId)
        }else{
            this.getLocalStorage()
        }
        if(this.user !== undefined) {
            if(this.user.firstName !== undefined && this.fields.firstNameContact.val == '') {
                this.fields.firstNameContact.val = this.user.firstName
            }
            if(this.user.lastName !== undefined && this.fields.lastNameContact.val == '') {
                this.fields.lastNameContact.val = this.user.lastName
            }
            if(this.user.email !== undefined && this.fields.emailContact.val == '') {
                this.fields.emailContact.val = this.user.email
            }
        }
    }
}
</script>

<style>
.swiper-slide {
    padding-bottom: 40px;
}
.ck.ck-button .ck.ck-tooltip {
    display: none;
}
.ck.ck-content p+p {
    @apply mt-4;
}
.ck.ck-content {
    min-height: 260px;
}
.vs__search {
    padding: 0;
}
</style>